import React, {PureComponent} from 'react';
import Select from 'react-select';
import {FormattedMessage} from 'react-intl';
import {Button, Fade, FormGroup, InputGroup, InputGroupAddon, Label} from 'reactstrap';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import {array} from 'prop-types';
import Icon from '../Icon/Icon';

const makeDomains = (domains = []) => {
  return domains.map((domain, index) => ({
    label: `http://${domain}/`,
    value: index,
  }));
};

class StreamTDSParkedDomain extends PureComponent {
  static propTypes = {
    domains: array.isRequired
  };

  static defaultProps = {
    domains: []
  };

  constructor(props) {
    super(props);

    const domains = makeDomains(props.domains);

    this.state = {
      copied: false,
      domains,
      selected: domains[0],
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const domains = makeDomains(nextProps.domains);
    const {value} = this.state.selected;
    const selected = domains.find(domain => value === domain.value) || null;

    this.setState(() => ({domains, selected}));
  }

  componentDidMount() {
    this._mounted = true;
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  handleChange = selected => {
    if (selected) {
      this.setState(() => ({selected}));
    }
  };

  handleCopy = () => {
    this.setState(
      () => ({copied: true}),
      () => {
        setTimeout(() => {
          this._mounted && this.setState(() => ({copied: false}));
        }, 1200);
      },
    );
  };

  render() {
    const {copied, selected, domains} = this.state;
    const {sm} = this.props

    return (
      <FormGroup>
        <Label for="flow-parked-domain">
          <FormattedMessage id="flow.form.parked-domain" defaultMessage="Parked domain"/>{' '}
          <Fade in={copied} tag="span" className="copy-message">
            <FormattedMessage id="flow.copied" defaultMessage="copied to clipboard"/>
          </Fade>
        </Label>
        <InputGroup>
          <Select
            className={sm ? 'Select--sm' : ''}
            id="flow-parked-domain"
            clearable={false}
            value={selected}
            options={domains}
            onChange={this.handleChange}
          />
          <InputGroupAddon addonType="append">
            <CopyToClipboard text={selected.label} onCopy={this.handleCopy}>
              <Button type="button" color="primary">
                <Icon type="copy"/>{' '}
                <FormattedMessage id="flow.form.link.copy" defaultMessage="Copy"/>
              </Button>
            </CopyToClipboard>
          </InputGroupAddon>
        </InputGroup>
      </FormGroup>
    );
  }
}

export default StreamTDSParkedDomain;
